export default __webpack_public_path__ + "static/media/24.9e04b74a.png";